var productVariantSku = {

    elements: {},

    init: function() {
        if(typeof BoosterTheme == 'undefined') {
            return;
        }

        if(!this.getElements()) {
            return;
        }

        this.filter();
        this.setEvents();
    },

    getElements: function() {
        this.elements.idInput = jQuery('form[action="/cart/add"] input[name="id"]');
        if(!this.elements.idInput.length) {
            return false;
        }

        this.elements.wrappers = jQuery('.product-variant-sku');
        if(!this.elements.wrappers.length) {
            return false;
        }

        return true;
    },

    filter: function() {
        this.elements.wrappers.addClass('product-variant-sku--disabled');

        var selectedVariantId = this.elements.idInput.val();

        if(selectedVariantId == -1) {
            return;
        }

        this.elements.wrappers.each(function() {
            var wrapper = jQuery(this);
            var variantId = wrapper.data('variant-id');

            if(typeof variantId == 'undefined') {
                return true;
            }

            if(variantId != selectedVariantId) {
                return true;
            }

            wrapper.removeClass('product-variant-sku--disabled');
        });
    },

    setEvents: function() {
        var _self = this;

        BoosterTheme.swatches.THEME_UTILS.events.on('booster:variant:select', function(arguments) {
            _self.filter();
        });
        BoosterTheme.swatches.THEME_UTILS.events.on('booster:variant:deselect', function(arguments) {
            _self.filter();
        });
    }

};

function initProductVariantSku() {
    if(typeof BoosterTheme == 'undefined') {
      setTimeout(initProductVariantSku, 200);
  
      return;
    }
  
    productVariantSku.init();
  }
  
  jQuery(document).ready(function() {
    initProductVariantSku();
  });